"use client";
import { forwardRef, memo } from "react";
import { TextFieldProps } from "@mui/material";
import AppTextField from "./AppTextField";

const AppTextarea = forwardRef(
  (
    {
      height = "300px",
      ...otherProps
    }: Omit<TextFieldProps, "multiline"> & { height?: string },
    ref
  ) => {
    return (
      <AppTextField
        sx={{
          textarea: {
            height: `${height}!important`,
            overflowY: "auto !important",
          },
        }}
        {...otherProps}
        multiline={true}
        ref={ref}
      />
    );
  }
);
AppTextarea.displayName = "AppTextarea";
export default memo(AppTextarea);
